<div class="atlas-dialog-container">
  <atlas-dialog-header
    headerText="Share Map"
    i18n-headerText="@@shareMapHeader"
  ></atlas-dialog-header>

  <mat-dialog-content class="mat-dialog-content">
    <div class="title-container">
      <mat-form-field appearance="outline" class="title-field">
        <mat-label i18n="@@mapTitleLabel">Title</mat-label>
        <input matInput type="text" [formControl]="titleControl" required />
        @if (titleControl.touched && titleControl.invalid) {
          <mat-error i18n="@@shareMapTitleRequired">
            Title cannot be empty.
          </mat-error>
        }
      </mat-form-field>
      <div class="button-padding">
        <button
          class="save-map-button secondary-button"
          mat-flat-button
          (click)="onSaveMapClicked()"
          [disabled]="titleControl.invalid || ((isSavingMap$ | async) ?? false)"
        >
          <span i18n="@@saveMapButton">Share</span>
        </button>
      </div>
    </div>
  </mat-dialog-content>

  <div class="reports-label" i18n="@@shareLabel">Share</div>
  <div class="url-container">
    <mat-form-field appearance="outline">
      <mat-label i18n="@@mapLinkLabel">Map Link</mat-label>
      <input
        matInput
        type="text"
        [value]="(shareMapUrl$ | async) ?? ''"
        readonly
      />
    </mat-form-field>
    <div class="button-padding">
      <button
        class="copy-button secondary-button"
        mat-flat-button
        (click)="onCopyClicked()"
        [disabled]="
          ((isSavingMap$ | async) ?? false) ||
          !((shareMapUrl$ | async) ?? '') ||
          isCopying
        "
      >
        @if (!((isSavingMap$ | async) ?? false)) {
          <span i18n="@@copyButton">Copy</span>
        }
        @if ((isSavingMap$ | async) ?? false) {
          <mat-spinner
            class="copy-button-spinner"
            diameter="24"
            strokeWidth="2"
          ></mat-spinner>
        }
      </button>
    </div>
  </div>

  <atlas-dialog-footer>
    <div class="dialog-buttons-container">
      <atlas-dialog-cancel-button
        label="Close"
        i18n-label="@@closeButton"
      ></atlas-dialog-cancel-button>
      <button
        mat-flat-button
        color="primary"
        class="launch-map-button"
        aria-label="Launch Map"
        (click)="onLaunchMapClicked()"
        [disabled]="!((shareMapUrl$ | async) ?? '')"
      >
        <span i18n="@@launchMapButton">Launch Map</span>
      </button>
    </div>
  </atlas-dialog-footer>
</div>
